import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener("click", async (e) => {
  const button = e.target.closest("#add-recycling-satchel-button");
  if (!button) return;

  const VARIANT_ID = 46743974936804;

  try {
   
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1 }),
    });

    if (!response.ok) throw new Error("Failed to add item");

   
    const icon = button.querySelector(".upparel-plus");
    if (icon) icon.textContent = "✓";

    
    localStorage.setItem("openCartDrawerAfterReload", "true");

    
    window.location.reload();

  } catch (err) {
    console.error("Error adding product:", err);
  }
});


document.addEventListener("DOMContentLoaded", () => {
  if (localStorage.getItem("openCartDrawerAfterReload") === "true") {
    localStorage.removeItem("openCartDrawerAfterReload");

   
    setTimeout(() => {
      if (window.NM && NM.CartDrawer && typeof NM.CartDrawer.open === "function") {
        NM.CartDrawer.open();
      } else {
        
        const cartIcon = document.querySelector('[data-nm-cart-trigger]');
        if (cartIcon) cartIcon.click();
      }
    }, 800); 
  }
});
